export default __webpack_public_path__ + "static/phone-meds-cbe09ac21d6f76c828a35d96519908dd.webp";